
export default function ServiceAreas() {
  const areas = [
    'Westchester',
    'Kendall / West Kendall',
    'Tamiami',
    'Coral Gables (nearby)',
    'Doral (nearby)',
    'Sweetwater',
    'South Miami (nearby)',
    'Pinecrest (nearby)',
    'Fontainebleau',
    'Olympia Heights',
    'University Park',
    'Sunset'
  ];

  return (
    <section id="service-areas" className="py-24 bg-gradient-to-br from-cyan-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          {/* Left Content */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-900 mb-4">
              Proudly Serving Miami + Nearby Areas
            </h2>
            <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-cyan-500 mb-6"></div>
            
            <p className="text-lg text-blue-800 leading-relaxed mb-8">
              Based in Miami (33165). If you're nearby, call—chances are we can help.
            </p>

            <a
              href="tel:3052793585"
              className="inline-flex items-center px-6 py-3 border-2 border-blue-900 text-blue-900 font-bold rounded-full hover:bg-blue-900 hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-map-pin-line mr-2"></i>
              Check Your Area
            </a>
          </div>

          {/* Right - Areas List & Map */}
          <div className="lg:col-span-3 space-y-8">
            {/* Areas Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {areas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-3 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-300 border border-cyan-100"
                >
                  <div className="w-8 h-8 bg-gradient-to-br from-cyan-400 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <span className="text-blue-900 font-medium">{area}</span>
                </div>
              ))}
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57503.89847892!2d-80.35!3d25.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b9c1e1e1e1e1%3A0x1e1e1e1e1e1e1e1e!2sMiami%2C%20FL%2033165!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Service Area Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
